module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-tree-1-0eceb64b66ce5927188cfd5969579a50.png";